module.exports = "<div ng-repeat=\"alert in $ctrl.messages\" class=\"message-wrapper\">\n  <div uib-alert class=\"alert-message\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"$ctrl.close(alert.id)\"><span ng-bind-html=\"alert.message\"></span></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/alert-messages/alert-messages.html
// module id = 69
// module chunks = 0